import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { ViewerContainerComponent } from './containers/viewer-container/viewer-container.component';

const routes: Routes = [
    {
        path: ':recordId',
        component: ViewerContainerComponent
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class ViewerRoutingModule {}
